import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { URLS_CONST } from '../../constants/url-constants';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private headerStateSubject: BehaviorSubject<any> = new BehaviorSubject<any>({
    showCalendarButton: true,
    showSignedInAsButton: true,
    showChangeAccessLevelButton: true
  });
  public headerState$: Observable<any> = this.headerStateSubject.asObservable();
  constructor() { }

  setHeaderState(state: any): void {
    this.headerStateSubject.next(state);
  }

  toggleSignedInAsButtonVisibility(visible: boolean): void {
    const currentState = this.headerStateSubject.getValue();
    currentState.showSignedInAsButton = visible;
    this.headerStateSubject.next(currentState);
  }

  toggleChangeAccessLevelButtonVisibility(visible: boolean): void {
    const currentState = this.headerStateSubject.getValue();
    currentState.showChangeAccessLevelButton = visible;
    this.headerStateSubject.next(currentState);
  }
  changeAccessLevelContainerVisibility(visible: boolean): void {
    const currentState = this.headerStateSubject.getValue();
    currentState.changeAccessLevelContainerVisible = visible;
    this.headerStateSubject.next(currentState);
  }

}
